// extracted by css-extract-rspack-plugin
export default {"cls1":"ToolsMenu-cls1_YEy","cls2":"ToolsMenu-cls2_ZG6 ToolsMenu-cls1_YEy"};